import styled from "styled-components";
import { brandhighlight, brandprimary, neutral10, neutral8, neutral4, tertiarywarning, brandmedium, neutral7, brandlight, neutral2, } from "../../css/colors";
import { media } from "../../styles/breakpoints";
import { secondaryFontFamily, primaryFontFamily, primaryFontFamilyBold, } from "../../styles/fontFamilyTypes";
export const Container = styled.div `
  position: relative;
`;
export const Background = styled.div `
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  @media ${media.small.down} {
    display: none;
  }
`;
export const BackgroundM = styled(Background) `
  display: block;
  @media ${media.small.up} {
    display: none;
  }
`;
export const BackgroundOverLay = styled.div `
  background-image: linear-gradient(
    to bottom,
    rgba(26, 28, 33, 0.72),
    rgb(26 28 33 / 95%)
  );
  position: relative;
  z-index: 1;
  padding: 90px 16px;
  overflow-x: scroll;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
    scrollbar-width: none;
  }
  @media ${media.xsmall.down} {
    background-image: linear-gradient(
      to bottom,
      rgb(26 28 33 / 38%),
      rgb(26 28 33 / 39%)
    );
    padding: 15px 16px 30px 16px;
  }
`;
export const PremiumLogo = styled.div `
  text-align: center;
  position: relative;
  @media ${media.xsmall.down} {
    padding-top: 0px;
  }

  .logo {
    width: 344px;
    @media ${media.small.down} {
      display: none;
    }
  }

  .premium-image {
    width: 344px;
    @media ${media.small.down} {
      width: 140px;
    }
  }
`;
export const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 23px 0px;

  .desc {
    font-family: ${secondaryFontFamily};
    font-size: 32px;
    font-weight: 500;
    line-height: 1.38;
    letter-spacing: 0.64px;
    text-align: center;
    color: ${neutral10};
    width: 700px;
    @media ${media.small.down} {
      font-size: 22px;
      line-height: 1.32;
      letter-spacing: 0.44px;
      width: 300px;
    }
  }
`;
export const UpcellWrapper = styled.div `
  overflow-x: scroll;
  display: flex;
  justify-content: center;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
    scrollbar-width: none;
  }
`;
export const UpCellMain = styled.div `
  display: flex;
  align-items: center;

  @media ${media.xsmall.down} {
    // width: 100%;
    overflow-x: scroll;
  }
`;
export const UiWrap = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  flex-direction: column;

  .recommended {
    font-family: ${primaryFontFamily};
    font-size: 12px;
    padding-left: 8px;
    font-weight: bold;
    line-height: 1.33;
    letter-spacing: normal;
    color: ${tertiarywarning};
  }

  .active {
    font-family: ${primaryFontFamilyBold};
    font-size: 24px;
    line-height: 1.33;
    text-align: left;
    font-weight: 500;
    color: ${neutral10};
  }

  .inactive {
    font-family: ${primaryFontFamily};
    font-size: 18px;
    text-align: left;
    font-weight: 500;
    color: ${neutral8};
  }
`;
export const SaveRecommendWrapper = styled.div `
  padding: 2px 4px;
  border-radius: 4px;
  text-align: center;
  align-items: center;
  background-color: ${({ isSave, isPlanActive }) => isSave ? (!isPlanActive ? `${brandlight + 30}` : `${brandprimary}`) : ""};

  .save {
    font-family: ${secondaryFontFamily};
    color: ${neutral10};
    font-size: 14px;
  }
`;
export const PremiumContainer = styled.div `
  align-items: center;
  display: flex;
  justify-content: center;
  @media ${media.xsmall.down} {
    margin-left: 7px;
  }
`;
export const InputWrapper = styled.div `
  display: flex;
  border: dashed 1.3px ${neutral4};
  background-color: ${brandmedium};
  align-items: center;
  padding: 10px 20px;
  margin-bottom: 24px;
  margin-top: 22px;
  border-radius: 6px;
  cursor: pointer;
  .redeemTitle {
    font-family: ${primaryFontFamily};
    font-size: 16px;
    color: ${neutral7};
    cursor: pointer;
    padding: 0px 4px;
    line-height: 1.29px;
  }
  .icon {
    width: 20.5px;
    height: 20.5px;
  }
`;
export const RedeemVoucherWrapper = styled.div `
  align-items: center;
  justify-content: center;
  display: flex;
  ${media.xsmall.down} {
    padding: 20px 28px 0px 20px;
  }
`;
export const ButtonContainer = styled.div `
  cursor: pointer;
  justify-content: center;
  display: flex;
  position: relative;
  .subscribe {
    font-family: ${primaryFontFamilyBold};
    font-size: 20px;
    width: 342px;
    height: 52px;
    line-height: 23px;
    font-weight: 700;
    letter-spacing: 0;

    @media ${media.xsmall.down} {
      width: 100%;
      font-family: ${primaryFontFamily};
      font-size: 14px;
      font-weight: bold;
      line-height: 1.29;
      letter-spacing: 0.28px;
      color: ${neutral10};
    }
    @media ${media.medium.down} {
      position: ${({ isFloatingBtn }) => isFloatingBtn ? "fixed" : "relative"};
      width: ${({ isFloatingBtn }) => (isFloatingBtn ? "90%" : "100%")};
      right: ${({ isFloatingBtn }) => (isFloatingBtn ? "5%" : "")};
      bottom: ${({ isFloatingBtn }) => (isFloatingBtn ? "2%" : "")};
    }
  }
`;
export const PricePlanContainer = styled.div `
  padding: 18px 24px;
  border-radius: 6px;
  width: 250px;
  height: ${({ isPlanActive }) => (isPlanActive ? "150px" : "125px")};
  ${({ isPlanActive }) => {
    if (isPlanActive) {
        return `background-image: linear-gradient(121deg, ${brandprimary} 2%, ${brandhighlight} 97%);`;
    }
    else {
        return `background-color: ${neutral4}`;
    }
}};
  margin: 0px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media ${media.small.down} {
    margin: 0px 10px;
    width: ${({ isPlanActive }) => (isPlanActive ? "160px" : "150px")};
    height: ${({ isPlanActive }) => (isPlanActive ? "160px" : "150px")};
  }

  &:first-child {
    margin-left: 0px;
  }
`;
export const MobileContainer = styled.div `
  padding: 18px 24px;
  border-radius: 6px;
  width: 166.67px;
  height: ${({ isPlanActive }) => (isPlanActive ? "48px" : "44px")};

  ${({ isPlanActive }) => {
    if (isPlanActive) {
        return `background-image: linear-gradient(121deg, ${brandprimary} 2%, ${brandhighlight} 97%);`;
    }
    else {
        return `background-color: ${neutral4}`;
    }
}};
  margin: 0px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:first-child {
    margin-left: 0px;
  }
`;
export const FloatingPlanPicker = styled.div `
  display: flex;
  overflow: hidden;
  .planlabel {
    font-family: ${primaryFontFamilyBold};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: ${neutral10};
    margin-right: 7px;
  }
  .active {
    font-family: ${primaryFontFamilyBold};
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    color: ${neutral10};
  }

  .inactive {
    font-family: ${primaryFontFamily};
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    color: ${neutral8};
  }
`;
export const PlanPickerMobileWrapper = styled.div `
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  margin-bottom: 14px;
  align-items: center;
`;
export const FloatingWrapper = styled.div `
  width: 100vw;
  background-color: ${neutral2};
  position: fixed;
  z-index: 1009;
  bottom: 0;
  padding: 16px;
  height: 150px;
  @media ${media.medium.up} {
    display: none;
  }
`;
export const PlanWrapper = styled.div `
  @media ${media.medium.up} {
    display: none;
  }
`;
export const DesktopView = styled.div `
  @media ${media.medium.down} {
    display: none;
  }
`;
export const Wrapper = styled.div `
  display: flex;
`;
export const BtnWrapper = styled.div `
  padding: 14px;
  width: 370px;
  margin-bottom: 20px;
  position: fixed;
  overflow-y: hidden;
`;
export const PlanWrappers = styled.div `
  @media ${media.medium.down} {
    padding: 14px;
    width: 370px;
    margin-bottom: 20px;
    position: absolute;
    margin-top: 75px;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 80%;
  }
  @media ${media.medium.up} {
    display: none;
  }
`;

